<div class="header main-app">
    <div class="avatar" [ngClass]="[ open  ? 'avatar-slide-open' : 'avatar-slide-close']">
        <div class="avatar-mask" data-title="Open"></div>
        <core-avatar-img [user]="user" [size]="40" [onlineIcon]="false"> </core-avatar-img>
    </div>
    <div class="info">
        <p [ngClass]="[ open  ? 'author-line-open' : 'author-line']">
            <span class="author-name">{{user.name}}</span>
        </p>
    </div>
</div>